<template>
  <div
    class="question-field">
    <div
      class="subtitle-1"
      style="margin-bottom: 1em;"
      v-if="!renderAsFormField"
      v-html="questionLabel">
    </div>
    <div
      class="question-field-wrapper">
      <component
        :is="component"
        :label="formLabel"
        :is-mandatory="isMandatory"
        :options="optionsForComponent"
        :question="question"
        :readonly="readonly"
        v-model="answerValue" />
      <QuestionVerification
        v-if="showVerificationControls"
        :question="question"
        :answer="answer"
        :readonly="readonly"
        @update-answer-verification="onUpdateAnswerVerification" />
    </div>
  </div>
</template>

<script>
import InputBool from '@/components/inputs/InputBool'
import InputNumber from '@/components/inputs/InputNumber'
import InputText from '@/components/inputs/InputText'
import InputDate from '@/components/inputs/InputDate'
import InputYear from '@/components/inputs/InputYear'
import InputSelect from '@/components/inputs/InputSelect'
import InputFreeSelect from '@/components/inputs/InputFreeSelect'
import InputMultiselect from '@/components/inputs/InputMultiselect'
import InputFile from '@/components/inputs/InputFile'
import QuestionVerification from './components/QuestionVerification'

export default {
  name: 'Question',

  components: {
    QuestionVerification
  },

  props: {
    question: {
      type: Object,
      default: void 0,
      required: true
    },

    answer: {
      type: Object,
      default: void 0
    },

    renderAsFormField: {
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      answerValue: this.answer ? this.answer.answer : void 0
    }
  },

  watch: {
    answer (val) {
      this.answerValue = val ? val.answer : void 0
    },

    answerValue (val) {
      this.$emit('update-answer', val, this.question, this.answer)
    }
  },

  computed: {
    component () {
      switch (this.question.type.type) {
        case 'bool':
          return InputBool
        case 'int':
        case 'float':
          return InputNumber
        case 'text':
          return InputText
        case 'date':
          return InputDate
        case 'year':
          return InputYear
        case 'select':
          return InputSelect
        case 'select_with_freetext':
          return InputFreeSelect
        case 'multiselect':
          return InputMultiselect
        case 'file':
          return InputFile
      }
      return false
    },

    questionLabel () {
      if (this.renderAsFormField) {
        return
      }

      let label = this.question.label

      const additionalLabel = []
      if (this.isMandatory) {
        additionalLabel.push('erforderlich')
      }
      if (this.question.type.type === 'multiselect') {
        additionalLabel.push('Mehrfachauswahl')
      }
      if (this.question.type.type === 'select_with_freetext') {
        additionalLabel.push('Freitext möglich')
      }

      if (additionalLabel.length > 0) {
        label += ' (' + additionalLabel.join(', ') + ')'
      }

      return label
    },

    formLabel () {
      if (!this.renderAsFormField) {
        return
      }

      return this.isMandatory
        ? this.question.form_label + ' (erforderlich)'
        : this.question.form_label
    },

    optionsForComponent () {
      return this.question.type.options
    },

    isMandatory () {
      return this.question && this.question.metadata
        ? this.question.metadata.mandatory
        : false
    },

    showVerificationControls () {
      return (
        this.renderAsFormField &&
        this.hasPermissionToVerifyCandidate &&
        (
          (this.question.metadata && this.question.metadata.verfication_required_for_finalize) ||
          (this.answer && this.answer.verification && (this.answer.verification.status || this.answer.verification.comment))
        )
      )
    }
  },

  methods: {
    onUpdateAnswerVerification (status, comment) {
      this.$emit('update-answer-verification', status, comment, this.question, this.answer)
    }
  }
}
</script>

<style lang="scss">
  .question-field {
    .question-field-wrapper {
      display: flex;

      > *:first-child {
        flex: 1 1 100%;
      }

      > *:last-child:not(:first-child) {
        flex: 0 0 auto;
        max-width: 15em;
        margin-left: 1em;
      }
    }
  }
</style>
